import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import 'aos/dist/aos.css';
import Header from '../components/header'
import Footer from '../components/Footer'
import './index.scss'
import "react-alice-carousel/lib/alice-carousel.css";
import favIcon from '../images/favicon1.png'
import ActiveWrapper from '../components/common/ActiveWrapper'
import chat from './chatLoader'

class Layout extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            width: '',
            height: ''
        }
    }

    scrollspyHandler(nav) {
        const getElementOffsetTop = document.getElementById(nav).offsetTop
        window.scroll({
            top: getElementOffsetTop,
            left: 0,
            behavior: "smooth",
        });
    }

    render() {
        const {children, data, location} = this.props;
        const locationName = location.pathname.replace('/', '');
        return <div className={`main-container ${locationName}`}>
            <Helmet
                title={data.site.siteMetadata.title}
                meta={[
                    {
                        name: 'description',
                        content: `Healthier Organisations, Happier People \n We help enterprises redefine their work`
                    },
                    {
                        property: "og:image",
                        content: `https://s3.ap-south-1.amazonaws.com/static.hubbler.in/logos/hubbler+logo+icon.png`
                    },
                    {name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no'}
                ]}
                link={[
                    {rel: 'shortcut icon', type: 'image/png', href: `${favIcon}`}
                ]}
                script={[
                    {src: '//js.hs-scripts.com/5150501.js', type: "text/javascript", async: true, defer: true}
                ]} />
            <Header siteTitle={data.site.siteMetadata.title} scrollspyHandler={this.scrollspyHandler.bind(this)}/>

            <div className={'boby-container'}>
                {children()}
            </div>
            <ActiveWrapper active={locationName !== 'signup'}>
                <Footer/>
            </ActiveWrapper>
        </div>
    }
}

Layout.propTypes = {
    children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js